<template>
  <div>
    <Row class="detail-header">
      <span>案件包信息</span>
      <slot name="operate-box"></slot>
    </Row>
    <div class="table-box">
      <!-- 公共包案件详情 -->
      <table v-if="defaultData.type=='P'" class="subject-header-table subject-table">
        <tbody>
          <tr>
            <td class="subject-table-color">案件包编号</td>
            <td colspan="7" class="tl">{{ defaultData.code }}</td>
          </tr>
          <tr>
            <td class="subject-table-color">案件区域</td>
            <td class="tl">{{ getLocationStr(defaultData.caseSaleBagLocationList) }}</td>
            <td class="subject-table-color">区域保护剩余时间</td>
            <td class="tl">
              <count-down :time="defaultData.protectSeconds || 0" />
            </td>
            <td class="subject-table-color">出证数量</td>
            <td class="tl">{{ (defaultData.certedNum || 0) }}/{{ defaultData.caseNum || 0 }}</td>
            <td class="subject-table-color">出售状态</td>
            <td class="tl">{{ defaultData.saleStateName || "" }}</td>
          </tr>
          <tr>
            <td class="subject-table-color">已预约案件</td>
            <td class="tl">{{ defaultData.reservedNum || 0 }}件</td>
            <td class="subject-table-color">已出售案件</td>
            <td class="tl">{{ defaultData.soldNum || 0 }}件</td>
            <td class="subject-table-color">待出售案件</td>
            <td class="tl">{{ defaultData.forSaleNum || 0 }}件</td>
            <td class="subject-table-color">案件总数</td>
            <td class="tl">{{ defaultData.caseNum || 0 }}件</td>
          </tr>
          <tr>
            <td class="subject-table-color">起批量</td>
            <td class="tl">{{ defaultData.batchNum || 0 }}</td>
            <td class="subject-table-color">已付定金</td>
            <td class="tl">{{ common.formateNumber(defaultData.prepaidFee || 0) }}</td>
            <td class="subject-table-color">已付尾款</td>
            <td class="tl">{{ common.formateNumber(defaultData.paidBalanceFee || 0) }}</td>
            <td class="subject-table-color">案件总价</td>
            <td class="tl">
              <Tooltip theme="light">
                <span>{{ common.formateNumber(defaultData.sellFee || 0) }}</span>
                <div slot="content">
                  <p>基础价格：{{ common.formateNumber(defaultData.baseFee || 0) }}</p>
                  <p>附加费用：{{ common.formateNumber(defaultData.surchargeFee || 0) }}</p>
                </div>
              </Tooltip>
            </td>
          </tr>
        </tbody>
      </table>
      <!-- 指派包详情 -->
      <table v-if="defaultData.type=='A'" class="subject-header-table subject-table">
        <tbody>
          <tr>
            <td class="subject-table-color">案件包编号</td>
            <td colspan="7" class="tl">{{ defaultData.code }}</td>
          </tr>
          <tr>
            <td class="subject-table-color">购买剩余时间</td>
            <td class="tl">
              <count-down :time="defaultData.caseSaleBagLicensor.dueSeconds || 0" />
            </td>
            <td class="subject-table-color">出证数量</td>
            <td class="tl">{{ (defaultData.certedNum || 0) }}/{{ defaultData.caseNum || 0 }}</td>
            <td class="subject-table-color">案件总数</td>
            <td class="tl">{{ defaultData.caseNum }}</td>
            <td class="subject-table-color">案件总价</td>
            <td class="tl">
              <Tooltip theme="light">
                <span>{{ common.formateNumber(defaultData.sellFee || 0) }}</span>
                <div slot="content">
                  <p>基础价格：{{ common.formateNumber(defaultData.baseFee || 0) }}</p>
                  <p>附加费用：{{ common.formateNumber(defaultData.surchargeFee || 0) }}</p>
                </div>
              </Tooltip>
            </td>
          </tr>
        </tbody>
      </table>

      <div class="detail-remark">
        备注：{{ defaultData.remark }}
      </div>
    </div>
    <Row class="detail-header" style="margin:16px 0 10px 0;">
      <span>案件信息</span>
      <div v-if="defaultData.type=='P'" class="operate-box">
        <Dropdown @on-click="option($event,'')">
          <a href="javascript:void(0)">
            <Icon type="ios-more" size="20" />
          </a>
          <DropdownMenu slot="list">
            <DropdownItem name="batchPay" :disabled="idList.length==0">批量预约支付</DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </div>
    </Row>
    <Row style="border:1px solid #dcdee2;border-bottom:0;">
      <checkbox-table
        ref="checkboxTable" :columns="infoCoulums"
        :data="tableData || []" :table-loading="tableLoading"
        @refreshList="getIdList($event)"
      >
        <template slot="more-actions" slot-scope="{ row, index }">
          <Dropdown v-if="row.saleState=='P'" @on-click="option($event,row)">
            <a href="javascript:void(0)">
              <Icon type="ios-more" size="20" />
            </a>
            <DropdownMenu slot="list">
              <DropdownItem name="pay">预约支付</DropdownItem>
              <DropdownItem name="caseNotes">备注</DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </template>
      </checkbox-table>
    </Row>
    <Row style="margin-top:10px;text-align:center;">
      <Page
        :total="table.totalRecords" show-total
        size="small"
        :current="table.pageNum"
        :page-size-opts="config.pageSizeOpts"
        :page-size="config.pageSize"
        prev-text="上一页" next-text="下一页"
        show-sizer
        show-elevator
        @on-change="changePage" @on-page-size-change="changeSize"
      />
    </Row>

    <!-- 发起支付modal -->
    <Modal
      v-model="payCtrl"
      title="预约支付"
      :width="800"
      :footer-hide="true"
    >
      <pre-pay-page
        v-if="payCtrl" :pay-obj-list="batchCtrl?idObjList:[idObj]"
        :default-data="defaultData" @closeModal="closeModal"
      />
    </Modal>
    <!-- 购买条款 -->
    <Modal
      v-model="provisionCtrl"
      title="购买条款"
      :width="800"
      :footer-hide="true"
      :closable="false"
      :mask-closable="false"
    >
      <pay-text @changeModal="changeModal" />
    </Modal>

    <!-- 案件详情 -->
    <Drawer
      v-model="caseInfoCtrl"
      width="900"
      :styles="{padding:'0px'}"
      :mask-style="{background:'rgba(0,0,0,0)'}"
    >
      <div slot="header" class="drawer-title">案件详情</div>
      <case-detail
        v-if="caseInfoCtrl" style="top:0;"
        :hide-case-evidence="true"
        :case-detail="caseDetail" :allow-edit="false"
      />
    </Drawer>

    <!-- 详情抽屉 -->
    <Drawer
      v-model="taskDetailCtrl"
      width="700"
      :mask-style="{background:'rgba(0,0,0,0)'}"
    >
      <div slot="header" class="drawer-title">任务详情</div>
      <!-- 详情 -->
      <task-info v-if="taskDetailCtrl" :task-detail="taskDetail" />
    </Drawer>
    <!-- 备注弹窗 -->
    <list-options
      :id="caseId" :type="type"
      @reloadList="changeCtrl"
    />
  </div>
</template>
<script>
import styles from '@/assets/globalStyle.scss'
import caseDetail from '../../case/caseDetail.vue'
import listOptions from '../../case/plugins/listOptions.vue'
import taskInfo from './../../taskHall/myTask/taskInfo.vue'
import payText from './../orderManage/payText.vue'
import surchargeFeeExpand from './surchargeFeeExpand.vue'
import prePayPage from './prePayPage.vue'
import obtainEvidenceImg from '@/assets/images/obtain-evidence.png'
import CaseMajor from '../../case/plugins/caseMajor.vue'
export default {
  components: {
    caseDetail,
    taskInfo,
    surchargeFeeExpand,
    prePayPage,
    listOptions,
    payText
  },
  props: ['bagId'],
  data () {
    return {
      styles: styles,
      obtainEvidenceImg: obtainEvidenceImg,
      caseInfoCtrl: false,
      caseDetail: '',
      taskDetailCtrl: false,
      provisionCtrl: false,
      taskDetail: '',
      columns: [
        {
          title: '案件编号',
          key: 'caseCode',
          width: 140,
          render: (h, params) => {
            const arr = []
            if (params.row.status != null && !params.row.status) {
              const iconDom = h('span', {
                class: 'descripe-icon',
                style: {
                  'marginRight': '5px',
                  'background': 'red'
                },
                attrs: {
                  title: '退回'
                }
              }, '退')
              arr.push(iconDom)
            }
            let imgLogo = ''
            switch (params.row.caseCategory) {
              case 'E':
                imgLogo = obtainEvidenceImg
                break
              default:
                break
            }
            const caseTypeDom = h('img', {
              attrs: {
                src: imgLogo
              },
              style: {
                width: '16px',
                height: '16px',
                verticalAlign: 'bottom'
              }
            })
            let itemDom = params.row.caseCode
            if (params.row.caseCategory === 'I') {
              const seriousCaseInfo = params.row.seriousCaseInfo || {}
              // 重案标识
              const caseMajorDom = h(CaseMajor, {
                props: {
                  level: seriousCaseInfo.level || '\xa0',
                  row: seriousCaseInfo
                }
              })
              itemDom = [params.row.caseCode, caseMajorDom]
            }
            const dom = h('a', {
              class: ['textover'],
              style: {
                color: styles.$globalMainColor
              },
              attrs: {
                title: params.row.caseCode
              },
              on: {
                'click': () => {
                  this.getCaseDetail(params.row.caseId)
                }
              }
            }, itemDom)
            arr.push(dom)
            imgLogo.length > 0 && arr.push(caseTypeDom)
            return arr
          }
        },
        {
          title: '所属任务',
          key: 'projectName',
          render: (h, params) => {
            return h('a', {
              class: ['textover'],
              attrs: { title: params.row.missionName },
              on: {
                'click': () => {
                  this.getTaskDetail(params.row.missionId)
                }
              }
            }, params.row.missionName)
          }
        },
        {
          title: '案件区域',
          key: 'provinceName',
          render: (h, params) => {
            const str = `${params.row.provinceName || ''}${params.row.cityName || ''}${params.row.areaName || ''}`
            return h('span', {
              class: ['textover'],
              attrs: { title: str }
            }, str)
          }
        },
        {
          title: '对方当事人',
          key: 'caseExtend',
          render: (h, params) => {
            if (!params.row.caseExtend) {
              return h('span', '')
            }
            const domArr = []
            const idArr = params.row.caseExtend.litigantIds ? params.row.caseExtend.litigantIds.split(',') : []
            const categoryArr = params.row.caseExtend.litigantCategories ? params.row.caseExtend.litigantCategories.split(',') : []
            const nameArr = params.row.caseExtend.litigantNames ? params.row.caseExtend.litigantNames.split(',') : []
            nameArr.forEach((item, index) => {
              const iconDom = h('span', {
                class: 'descripe-icon',
                style: {
                  'marginRight': '5px'
                }
              }, categoryArr[index] && categoryArr[index] === 'M' ? '生' : '销')
              const spanDom = h('span', item)
              const pDom = h('p', {
                class: 'textover',
                attrs: { title: item },
                style: {
                  'marginBottom': index != nameArr.length - 1 ? '5px' : '0'
                }
              }, [iconDom, spanDom])
              domArr.push(pDom)
            })
            return h('div', {
              style: {
                'padding': nameArr.length > 1 ? '5px 0' : '0'
              }
            }, domArr)
          }
        },
        {
          title: '取证状态',
          key: 'certStateName',
          render: (h, params) => {
            let color = ''
            switch (params.row.certState) {
              case 'P': color = 'warning'; break
              case 'W': color = 'blue'; break
              case 'A': color = 'green'; break
            }
            return h('Tag', {
              class: ['textover'],
              attrs: { color: color }
            }, params.row.certStateName)
          }
        },
        {
          title: '出售价格',
          key: 'sellFee',
          render: (h, params) => {
            if (params.row.caseSaleBagItemExtend) {
              return h(surchargeFeeExpand, {
                props: {
                  type: params.row.tortCategoryName,
                  row: params.row,
                  isBaseFee: true,
                  scale: params.row.scale || 0
                }
              })
            } else {
              return h('span', this.common.formateNumber(params.row.sellFee || 0))
            }
          }
        },
        {
          title: '出售状态',
          key: 'saleState',
          render: (h, params) => {
            let color
            const state = params.row.saleState
            switch (true) {
              case state == 'P':color = 'warningColor'; break
              case state == 'PR':color = 'successColor'; break
              case state == 'S':color = 'infoColor'; break
            }
            return h('Tag', {
              class: 'textover',
              attrs: {
                title: params.row.saleStateName,
                color: styles[color]
              },
              style: {
                borderRadius: '11px'
              }
            }, params.row.saleStateName)
          }
        },
        {
          title: '备注',
          key: 'caseMemo',
          render: (h, params) => {
            let color
            const state = params.row.caseMemo && params.row.caseMemo.attention
            const str = params.row.caseMemo ? params.row.caseMemo.memo : ''
            switch (true) {
              case state == 'N':color = 'globalMainColor'; break
              case state == 'Y':color = 'errorColor'; break
            }
            return h('a', {
              class: 'textover',
              attrs: {
                title: str
              },
              style: {
                color: styles[color]
              },
              on: {
                'click': () => {
                  this.option('caseNotes', params.row)
                }
              }
            }, str)
          }
        }
      ],
      table: { // 表格数据接口的相关参数
        pageSize: this.config.pageSize,
        pageNum: 1,
        totalRecords: 1
      },
      id: '',
      caseId: '',
      type: '',
      idObj: {},
      idList: [],
      idObjList: [],
      payCtrl: false,
      isSumbit: false,
      codeCtrl: false,
      batchCtrl: false,
      tableLoading: false,
      payObj: {},
      tableData: '',
      defaultData: ''
    }
  },
  computed: {
    infoCoulums() {
      let arr = []
      const objArr = [
        {
          title: '案件类型',
          key: 'tortCategoryName'
        },
        {
          title: '案件性质',
          key: 'code'
        }
      ]
      if (this.defaultData.type == 'P') {
        arr = [{ type: 'selection', width: 30, align: 'center' }]
        objArr.push({ title: '操作', slot: 'action' })
      }
      this.columns.forEach((item, index) => {
        arr.push(item)
      })
      return arr.concat(objArr)
    }
  },
  watch: {
    defaultData(newVal, oldVal) {}
  },
  created() {},
  beforeMount() {
    this.getBagDetail()
  },
  mounted() {},
  updated() {},
  methods: {
    changeModal() {
      this.provisionCtrl = false
      this.payCtrl = true
    },
    getBagDetail() {
      const url = '/settlement/trade/sale/bag/' + this.bagId
      this.$get(url).then(res => {
        if (res.code == 0) {
          this.defaultData = res.data
          this.getData()
        }
      })
    },
    // 获取案件详情
    getCaseDetail(id) {
      // 公共包指派包查看案件详情需要调用特殊的接口
      const url = '/business/case/' + id + '/lawyer/prepaid'
      this.$get(url).then(res => {
        if (res.code == 0) {
          this.caseDetail = res.data
          this.caseInfoCtrl = true
        }
      })
    },
    getTaskDetail(id) {
      const url = '/business/mission/' + id
      this.$get(url).then(res => {
        if (res.code === 0) {
          this.taskDetail = res.data || {}
          this.taskDetailCtrl = true
        } else {
          this.$Message.error(res.message)
        }
      })
    },
    getData() {
      const url = '/settlement/trade/sale/bag/item'
      const ajaxData = {
        current: this.table.pageNum,
        size: this.table.pageSize,
        bagId: this.defaultData.id
      }
      Object.assign(ajaxData, this.searchForm)
      this.tableLoading = true
      this.$get(url, ajaxData).then(res => {
        this.tableLoading = false
        if (res.code == 0) {
          this.tableData = res.data.records || []
          this.tableData.forEach((item, index) => {
            if (item.saleState != 'P') {
              item._disabled = true
            }
          })
          this.table.totalRecords = res.data.total
        }
      })
    },
    getLocationStr(arr) {
      const location = []; const json = {}; let str
      arr.forEach(item => {
        if (item.flag) {
          if (!json[item.province]) {
            json[item.province] = item.provinceName
          }
        } else {
          location.push(item.cityName)
        }
      })
      for (const key in json) {
        location.push(json[key])
      }
      str = location.join('，')
      return str
    },
    option(name, row) {
      this.batchCtrl = false
      switch (name) {
        case 'pay':
          this.id = row.id
          this.idObj = row
          this.provisionCtrl = true
          // this.payCtrl = true
          break
        case 'batchPay':
          this.batchCtrl = true
          this.provisionCtrl = true

          // this.payCtrl = true
          break
        case 'caseNotes':
          this.caseId = row.caseId
          this.type = name
          break
      }
    },
    // 关闭备注弹框
    changeCtrl(isReload) {
      if (isReload) {
        this.reloadTable()
      }
      this.type = ''
    },
    // 重载table
    reloadTable() {
      this.getData()
    },
    sumbitPay() {

    },
    successFunc(reload) {
      this.codeCtrl = true
      this.$refs.checkboxTable.clearSelected()
      this.getData()
      this.$emit('reloadList')
    },
    changePage(page) {
      this.table.pageNum = page
      this.getData()
    },
    changeSize(size) {
      this.table.pageSize = size
      this.getData()
    },
    closeModal(reload) {
      this.payCtrl = false
      this.$refs.checkboxTable.clearSelected()
      if (reload) {
        this.getBagDetail()
        this.$emit('reloadList')
      }
    },
    /* --------------------批量操作start---------------------*/
    getIdList(list) {
      this.idObjList = []
      this.idList = list.map(item => {
        this.idObjList.push(item)
        return item.id
      })
    }
    /* --------------------批量操作end---------------------*/
  }
}
</script>
<style lang="scss" scoped>
@import "./../mailingList/print.scss";
@import "./packageDetail.scss";
.detail-remark{
  margin-top: 10px;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/view/tradingCenter/casePackage/packageDetail.vue